import API from "../../../../app/api";

export const getdontMissed = async (categorySlug) => {
  try {
    if (!categorySlug) {
      throw new Error("Dont Missed category slug is required");
    }

    const res = await API.get(
      `/products/details/recommended/dont-missed/${categorySlug}`
    );

    if (!res?.data?.success) {
      throw new Error(res?.data?.message || "Failed to fetch Dont Missed");
    }

    // console.log("Dont Missed API Response:", res.data.data);

    return res.data.data ?? [];
  } catch (error) {
    console.error("getdontMissed error:", error);
    throw error;
  }
};